import { render, staticRenderFns } from "./companyEvaluate.vue?vue&type=template&id=fc6e681c&scoped=true"
import script from "./companyEvaluate.vue?vue&type=script&lang=js"
export * from "./companyEvaluate.vue?vue&type=script&lang=js"
import style0 from "./companyEvaluate.vue?vue&type=style&index=0&id=fc6e681c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6e681c",
  null
  
)

export default component.exports